module.exports = __webpack_public_path__ + "img/16-1.2f273683.png";